module.exports = __webpack_public_path__ + "img/icon_notification_yezza_read.e405a0ef.svg";